"use strict";

var _slicedToArray = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var core_1 = require("@material-ui/core");

var icons_1 = require("@material-ui/icons");

var styles_1 = require("@material-ui/core/styles");

var useStyles = styles_1.makeStyles(function (theme) {
  return styles_1.createStyles({
    content: {
      padding: theme.spacing(1, 2)
    }
  });
});

var PopoverFilter = function PopoverFilter(props) {
  var classes = useStyles();

  var _react_1$default$useS = react_1.default.useState(null),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      anchorEl = _react_1$default$useS2[0],
      setAnchorEl = _react_1$default$useS2[1];

  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
  };

  var open = Boolean(anchorEl);
  var children = props.children,
      isActive = props.isActive;
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(core_1.IconButton, {
    onClick: handleClick,
    style: {
      color: isActive ? '#000' : '#ccc'
    }
  }, react_1.default.createElement(icons_1.FilterList, null)), react_1.default.createElement(core_1.Popover, {
    open: open,
    anchorEl: anchorEl,
    onClose: handleClose,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    }
  }, react_1.default.createElement("div", {
    className: classes.content
  }, children)));
};

exports.default = PopoverFilter;